import type { IProcedureGetOne } from '../../interfaces/procedureGetOne';
import { ProcedureStatus } from '../../../../common/enums/procedureStatus';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface IEditProcedureButtonProps {
    editProcedure?: () => Promise<void>;
    procedure: IProcedureGetOne;
}

export function EditProcedureButton(props: IEditProcedureButtonProps) {
    if (
        !props.procedure.authorization ||
        !props.procedure.authorization.canUpdateProcedure ||
        props.procedure.status !== ProcedureStatus.inProgress ||
        !props.editProcedure
    ) {
        return null;
    }

    return (
        <Button
            automation="editProcedure"
            color="secondary"
            large
            onClick={props.editProcedure}
        >
            {translateKey('common.edit')} {translateKey('procedure.procedure').toLowerCase()}
        </Button>
    );
}
